module.exports = __webpack_public_path__ + "static/media/useCase113x.cba1b05b.png";